import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import SendIcon from '../../../assets/icons/send-icon';
import useStyles from './styles';

const SendFileToDeviceButton = ({
  row,
  disabled,
  callback,
  id,
}: {
  row: any;
  disabled: boolean;
  callback: Function;
  id: string;
}) => {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="flex-end">
      <Button
        className={classes.root}
        id={`send-to-device-${id}`}
        onClick={() => callback(row)}
        variant="outlined"
        size="small"
        disabled={disabled}
        endIcon={<SendIcon />}
      >
        <Typography variant="button">send to device</Typography>
      </Button>
    </Box>
  );
};

export default SendFileToDeviceButton;
